import React, { memo } from 'react';

import Button from '../helpers/Button';
import { AppPage } from '../AppPage';
import { GridCard } from '../helpers/GridCard';
import { TagTable } from './TagTable';

import style from './style.module.css';

const TagManagementComponent = ({
  loading,
  tags,
  isSuper,
  onAdd,
  onEdit,
  onDelete,
  onDeleteParent,
  onClick,
  onExport,
}) => {
  const toolbar = (
    <div className={style.toolbar}>
      <Button onClick={onExport}>
        <i aria-hidden="true" className="fa fa-download" /> Export
      </Button>
      <Button disabled={loading || !isSuper} onClick={onAdd}>
        <i aria-hidden="true" className="fa fa-plus" /> Add New
      </Button>
    </div>
  );

  return (
    <AppPage overline="Management" title="Tags" toolbar={toolbar}>
      <GridCard className={style.table} dense>
        <TagTable
          isSuper={isSuper}
          loading={loading}
          onClick={onClick}
          onDelete={onDelete}
          onDeleteParent={onDeleteParent}
          onEdit={onEdit}
          tags={tags}
        />
      </GridCard>
    </AppPage>
  );
};

export const TagManagement = memo(TagManagementComponent);
